<template>
    <ion-row class="mb-4" v-if="storeLocation.displayStatus && !!storeLocation.displayStatus.status">
        <ion-badge :color="storeLocation.displayStatus.toColor">{{ storeLocation.displayStatus.toString }}</ion-badge>
    </ion-row>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IonBadge, IonRow } from '@ionic/vue';
import { StoreLocation } from '@/models/locationModels';
export default defineComponent({
    props: {
        storeLocation: { type: Object as PropType<StoreLocation>, required: true },
    },
    components: { IonRow, IonBadge },
});
</script>

<style scoped>
ion-badge {
    color: #556269;
}
</style>
